import React, { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { api } from "../lib/api";
import { useAuth } from "../context/AuthContext";
import { setSessionToken } from "../lib/sessionStore";

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
export default function AuthCallback() {
  const navigate = useNavigate();
  const { refresh } = useAuth();
  const processed = useRef(false);

  useEffect(() => {
    if (processed.current) return;
    processed.current = true;
    (async () => {
      const hash = window.location.hash || "";
      const match = hash.match(/session_id=([^&]+)/);
      if (!match) {
        navigate("/login", { replace: true });
        return;
      }
      const sessionId = decodeURIComponent(match[1]);
      try {
        const { data } = await api.post("/auth/session", { session_id: sessionId });
        if (data.session_token) await setSessionToken(data.session_token);
        await refresh();
        window.history.replaceState({}, "", window.location.pathname);
        navigate("/dashboard", { replace: true, state: { user: data.user } });
      } catch (e) {
        navigate("/login", { replace: true });
      }
    })();
  }, [navigate, refresh]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-[#F7F5F0]">
      <div data-testid="auth-callback-loading" className="text-[#2C332A] font-light text-lg">
        Signing you in…
      </div>
    </div>
  );
}
